class Currency {
    constructor(element, config = {}) {
        this.config = {
            decimalNumber: false,
            separatorThousand: '.',
            separatorDecimal: ',',
            prefix: '',
            subfix: '',
            ...config 
        };
        
        this.element = element;
        if (this.element) {
            this.attachListeners();
            this.formatCurrency();
        }
    }

    // Attach event listeners to the element
    attachListeners() {
        this.element.addEventListener('keyup', () => this.formatCurrency());
        this.element.addEventListener('blur', () => this.formatCurrency(true));
    }

    // Format the number to add thousand separators
    formatNumber(n, separatorThousand = this.config.separatorThousand) {
        return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, separatorThousand);
    }

    // Main formatting logic
    formatCurrency(blur = false) {
        let inputVal = this.element.value;
    
        if (inputVal === "") return;
    
        let originalLength = inputVal.length;
        let caretPos = this.element.selectionStart;
    
        if (this.config.separatorDecimal !== false && inputVal.indexOf(this.config.separatorDecimal) > 0) {
            const decimalPos = inputVal.indexOf(this.config.separatorDecimal);
            let leftSide = inputVal.substring(0, decimalPos);
            let rightSide = inputVal.substring(decimalPos + 1);
    
            leftSide = this.formatNumber(leftSide);
            rightSide = this.formatNumber(rightSide, "");
    
            if (blur && this.config.decimalNumber !== false) {
                rightSide = rightSide.padEnd(this.config.decimalNumber, "0");
            }
    
            rightSide = rightSide.substring(0, this.config.decimalNumber !== false ? this.config.decimalNumber : rightSide.length);
    
            inputVal = `${this.config.prefix}${leftSide}${this.config.decimalNumber !== false ? this.config.separatorDecimal + rightSide : ''}${this.config.subfix}`;
        } else {
            inputVal = this.formatNumber(inputVal);
            inputVal = this.config.prefix + inputVal;
    
            if (blur && this.config.decimalNumber !== false) {
                inputVal += `${this.config.separatorDecimal}${"0".repeat(this.config.decimalNumber)}`;
            }
        }
    
        this.element.value = inputVal;
        caretPos = inputVal.length - originalLength + caretPos;
        this.element.setSelectionRange(caretPos, caretPos);
    }
}

// Initialize the class after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new Currency();
});

export default Currency;
